<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-07 09:45:46
 * @LastEditors: yd
 * @LastEditTime: 2020-09-17 15:15:42
--> 
<template>
  <div>
    <clientInt></clientInt>
  </div>
</template>

<script>
import clientInt from './clientInt'
export default {
  components: { clientInt },
  props: {},
  data () {
    return {

    };
  },
  created () { },
  mounted () { },
  methods: {

  },
  computed: {},
  watch: {},
};
</script>

<style scoped>
</style>
